<template>
  <div>
    <h1>To Do (Api)</h1>
    <input
      v-model.trim="newTodo"
      v-bind:class="[newTodo.length < 3 ? 'red' : 'green']"
    />
    <input
      value="Add"
      type="button"
      @click="addToDo()"
      :disabled="newTodo.length < 3"
    />
    <section v-if="errored">
      <p>
        We're sorry, we're not able to retrieve this information at the moment,
        please try back later
      </p>
    </section>

    <section v-else>
      <div v-if="loading">Loading...</div>
      <div v-bind:key="todo.id" v-for="todo in todos">
        <div class="todo-item" v-bind:class="{ 'is-complete': todo.completed }">
          <p>
            {{ todo.title }}
            <button @click="deleteTodo(todo.id)" class="del">x</button>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      todos: [],
      newTodo: "",
      loading: true,
      errored: false
    };
  },

  methods: {
    fetchData() {
      axios
        .get("https://jsonplaceholder.typicode.com/todos?_limit=5")
        .then(response => (this.todos = response.data))
        .catch(error => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    // deleteTodo(id) {
    //   debugger;
    //   this.loading = true;
    //   axios
    //     .delete(`https://jsonplaceholder.typicode.com/todos/${id}`)
    //     .then(res => (this.todos = this.todos.filter(todo => todo.id !== id)))
    //     .catch(err => console.log(err))
    //     .finally(() => (this.loading = false));
    // },
    addToDo() {
      this.loading = true;

      debugger;
      const _todo = {
        title: this.newTodo,
        completed: false
      };
      this.newTodo = "";
      //const { title } = this.newTodo;
      axios
        .post("https://jsonplaceholder.typicode.com/todos", _todo)
        .then(res => (this.todos = [...this.todos, res.data]))
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.del {
  background: #ff0000;
  color: #fff;
  border: none;
  padding: 5px 9px;
  border-radius: 50%;
  cursor: pointer;
  float: right;
}

.todo-item {
  background: #f4f4f4;
  padding: 10px;
  border-bottom: 1px #ccc dotted;
}

@media (max-width: 600px) {
  p {
    font-size: 200%;
  }
}
</style>
